// extracted by mini-css-extract-plugin
export default {"control":"styles_control__wmeA3","ltr":"styles_ltr__BUamS","left":"styles_left__tWE2g","right":"styles_right__BB15H","rtl":"styles_rtl__oxlqn"};